import { Injectable } from '@angular/core';
import { Http ,Headers,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';


/*
  Generated class for the UserServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class UserServiceProvider {

  constructor(public http: Http) {
    console.log('Hello UserServiceProvider Provider');
  }

  authenticatio(creadential){

  	//$http.post(_url, {}, _condigHeader);


		let headers = new Headers({
				'Authorization': 'Basic YWRtaW46OUVBQkI0RTFCRTU4RDE4RkYxMkM3RDU4Mjc5NjE=',
				'Accept': 'application/json; charset=utf-8',
				'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'				
			});
    let options = new RequestOptions({headers:headers})

  	return this.http.post('http://localhost:3000/api/auth/signin',creadential,options);


  }

}



// WEBPACK FOOTER //
// ./src/providers/user-service/user-service.ts